
import React from 'react';
import {
    atom,
} from 'recoil';
import { FetchResultType } from '../../fetchTypes';
import { ErpPlatforms, ErpSyncTypes } from '../../../common/types/ErpTypes';



export type TenantFirmType = {
    firmName: string,
    firmPath: string,
    firmCode: string,
    logoPath?: string,
    isPublicPayment?: boolean,
    licenseKey: string,
    taxCode: string,
    email?: string,
    web?: string,
    isErp:boolean,
    isB2bPackage?:boolean,
    isCustomerBalance: boolean,
    isCurrency:boolean,
    erpPlatform:ErpPlatforms,
    syncTypeId:ErpSyncTypes,
    erpType: string
}

export interface tenantStateType extends FetchResultType {
    firmInformations: TenantFirmType,
    isfirmAvailable: boolean
}

export const initialFirmInformation: TenantFirmType = {
    firmCode: "",
    firmName: "",
    firmPath: "",
    licenseKey: "",
    taxCode: "",
    erpPlatform:"",
    syncTypeId:1,
    isErp:false,
    isCustomerBalance:false,
    isCurrency:false,
    erpType:""
}
export const initialTenantInformationState: tenantStateType = {
    firmInformations: initialFirmInformation,
    isfirmAvailable: false,
    isFetching: true,
    isSuccess: false,
    isError: false,
    errorMessage: "",

}


export const tenantState = atom<tenantStateType>({
    key: "tenantState", // unique ID (with respect to other atoms/selectors)
    default: initialTenantInformationState,

});
